import React from "react";

const Loading = () => {
  return (
    <div className="section section-center" style={{display:"flex",height:"100vh", width: '100%'}}>
      <div className="loading"></div>
    </div>
  );
};

export default Loading;
